import packageJson from '../../package.json';
export const setStorage=(key, value)=>{
    localStorage.setItem(key, JSON.stringify(value));
    window.dispatchEvent(new Event("storage"));
};

export const setUser=(data, key=packageJson['client-key'])=>{
    localStorage.setItem(key, JSON.stringify(data));
    window.dispatchEvent(new Event("storage"));
};

export const setSiteConfigs=(data)=>{
    localStorage.setItem("site-configs", JSON.stringify(data));
    window.dispatchEvent(new Event("storage"));
};

export const clear=()=>{
    localStorage.clear();
    window.dispatchEvent(new Event("storage"));
};

export const getStorage=(key)=>{
    return JSON.parse(localStorage.getItem(key));
};

export const getUser=(key=packageJson['client-key'])=>{
    return JSON.parse(localStorage.getItem(key));
};

export const getSiteConfigs=()=>{
    return JSON.parse(localStorage.getItem("site-configs"));
};

export const onStorageUpdated=(f)=>{
    window.addEventListener('storage', f);
}
